import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NovaPersonsIcon = (props) => {
    const width = props.width ? props.width + 'px' : '42px';
    const height = props.height ? props.height + 'px' : '45px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 42 45"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M41.7859 40.6836H0V44.8581H41.7859V40.6836Z" />
            <path d="M30.9349 20.5322L24.0684 36.4251H28.6591L32.7086 27.0517L36.758 36.4251H41.3553L34.4822 20.5322H30.9349Z" />
            <path d="M32.8648 0.851562C28.0915 0.851562 24.2051 4.69109 24.2051 9.40676C24.2051 14.1224 28.085 17.962 32.8648 17.962C37.6447 17.962 41.5246 14.1224 41.5246 9.40676C41.5246 4.69109 37.6381 0.851562 32.8648 0.851562ZM32.8648 13.7874C30.4195 13.7874 28.4306 11.8226 28.4306 9.40676C28.4306 6.99095 30.4195 5.02609 32.8648 5.02609C35.3102 5.02609 37.3056 6.99095 37.3056 9.40676C37.3056 11.8226 35.3167 13.7874 32.8648 13.7874Z" />
            <path d="M10.8974 0.851562C6.12408 0.851562 2.24414 4.69109 2.24414 9.40676C2.24414 14.1224 6.12408 17.962 10.9039 17.962C15.6837 17.962 19.5637 14.1224 19.5637 9.40676C19.5637 4.69109 15.6772 0.851562 10.8974 0.851562ZM10.8974 13.7874C8.45204 13.7874 6.46316 11.8226 6.46316 9.40676C6.46316 6.99095 8.45204 5.02609 10.8974 5.02609C13.3427 5.02609 15.3381 6.99095 15.3381 9.40676C15.3381 11.8226 13.3492 13.7874 10.8974 13.7874Z" />
            <path d="M20.9836 20.0942H0.814453V24.2688H20.9836V20.0942Z" />
            <path d="M9.12203 23.6055H4.89648V36.4254H9.12203V23.6055Z" />
            <path d="M16.9091 23.6055H12.6836V36.4254H16.9091V23.6055Z" />
        </SvgStyled>
    );
};

export default NovaPersonsIcon;
